import { motion } from 'framer-motion';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { SourceFaviconStack } from './SourceFaviconStack';
import { ThinkingSource } from './webSearch.types';

interface ThinkingSourcesProps {
  sources: ThinkingSource[];
}

export const ThinkingSources = ({ sources }: ThinkingSourcesProps) => {
  const { t } = useTranslation();

  if (sources.length === 0) return null;

  return (
    <motion.div initial={{ opacity: 0, y: 4 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.2 }}>
      <SourceFaviconStack sources={sources} label={t('aiInsights.searchingSites', { count: sources.length })} />
    </motion.div>
  );
};
